import * as NavigationMenu from '@radix-ui/react-navigation-menu';
import { useRef } from 'react';

import { NavigationLink } from './NavigationLink';
import { NavigationLinkItem } from './types';

import styles from './desktopNavigation.css';

export interface NavigationSection {
  /** The links to used to populate the app's navigation components. */
  links: NavigationLinkItem[];
}
export function SingleSectionNav({ links }: NavigationSection) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  return (
    <div className={styles.navigationMenuList}>
      {links?.map((link: NavigationLinkItem) => (
        <NavigationMenu.Item key={link.to}>
          <NavigationMenu.Trigger asChild className={styles.navigationMenuTrigger}>
            <NavigationLink
              key={link.to}
              link={link}
              compact={false}
              onClick={() => dialogRef?.current?.close()}
              disabled={link.disabled}
              displayIcon={false}
            />
          </NavigationMenu.Trigger>
        </NavigationMenu.Item>
      ))}
    </div>
  );
}
